module.exports = __webpack_public_path__ + "static/media/premiereFois_01_full.b8c51eee.gif";